import { MessageService } from 'primeng/api';
import { AppInsightsService } from '../services/app-insights.service';

export interface ErrorContext {
  component: string;
  action: string;
  [key: string]: any;
}

export function notifyAndTrackError(msgService: MessageService, insights: AppInsightsService, err: unknown, ctx: ErrorContext, userMessage?: string) {
  const detail = userMessage || extractErrorMessage(err);
  msgService.add({ severity: 'error', summary: 'Error', detail });
  try {
    // Assuming AppInsightsService.trackException(err, props?) signature
    (insights as any).trackException(err, ctx);
  } catch {
    // swallow telemetry errors
  }
}

function extractErrorMessage(err: unknown): string {
  if (!err) return 'Unexpected error';
  if (typeof err === 'string') return err;
  if (err instanceof Error) return err.message;
  // Attempt to unwrap common HTTP patterns
  const anyErr: any = err as any;
  return anyErr?.error?.userMessage || anyErr?.error?.message || anyErr?.message || anyErr?.statusText || 'Unexpected error';
}

// Convenience wrapper when only message is needed
export function errorToast(msgService: MessageService, message: string) {
  msgService.add({ severity: 'error', summary: 'Error', detail: message });
}
